<template>
  <div id="app">
    <Header v-if="loggedIn"/>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/dashboard/Header.vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: { Header },
  computed: {
    ...mapState({
      token: state => state.auth.token,
    }),
    loggedIn() {
      return Boolean(this.token);
    },
  },
};
</script>

<style>
  #app {
    height: 100%;
  }
</style>
